import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
          path: '/',
          redirect:'home', //默认路径，重定向到网站首页
      },
      {
        path:'/home',
       
        meta:{isLogin: true},
        component:() => import('./components/Home.vue'), 
        children:[
            {
                path:'/',
                meta:{index:0},
                component: () => import( './components/FirstPage.vue')
            },
            {
                path:'/firstPage',
                name:'firstPage',
                meta:{isLogin: true},
                component:() => import('./components/FirstPage.vue'), 
             },{
                path:'/projects',
                name:'projects',
                meta:{isLogin: true},
                component:() => import('./components/Projects.vue'), 
             },
             {
                path:'/mapProducts',
                name:'mapProducts',
                meta:{isLogin: true},
                component:() => import('./components/MapProducts.vue'), 
             },
             {
                path:'/mapCases',
                name:'mapCases',
                meta:{isLogin: true},
                component:() => import('./components/MapCases.vue'), 
             },
             {
                path:'/pricePage',
                name:'pricePage',
                meta:{isLogin: true},
                component:() => import('./components/PricePage.vue'), 
             }
        ]
      },
      {
        path:'/mappingWindow',
        name:'mappingWindow',
        meta:{isLogin: true},
        component:() => import('./components/MappingWindow.vue'), 
        children:[
            {   
                path:'/addDataPage',
                name:'addDataPage',
                meta:{isLogin: true},
                component:() => import('./components/AddDataPage.vue')
            },
            {   
                path:'/userDataPage/:id/:fromPage',
                name:'userDataPage',
                props: true,
                meta:{isLogin: true},
                component:() => import('./components/UserDataPage.vue')
            },
        ]
     },{
         path:'/sharePage/:id',
         props: true,
         name:'sharePage',
         component:() => import('./components/SharePage.vue'),
     }
    ]
})
